import React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

@observer
class FlightOfferCard extends React.Component {
  handleClick = () => {
    this.props.onClick(this.props.flightOffer);
  };

  render() {
    const { t, flightOffer, link } = this.props;

    let images = [];
    if (flightOffer && flightOffer.files) {
      images = flightOffer.files.map(f => f.file);
    }
    const randomIndex = Math.floor(Math.random() * images.length);
    const image = images[randomIndex];

    return (
      <Link to={link || `/offer/${flightOffer.id}`} className='flight-offer-card' onClick={this.handleClick}>
        <div className='offer-card-image' style={{ backgroundImage: image ? `url('${image.url}')` : 'none' }}>
          <div className='image-overlay'></div>
        </div>
        <div className='offer-card-content'>
          <h2>{flightOffer.title}</h2>
          {flightOffer.location && flightOffer.location.name && (
            <div className='location'>
              {flightOffer.location.name}
            </div>
          )}
          {flightOffer.durationInMinutes && (
            <div className='duration'>
              {`${flightOffer.durationInMinutes} min`}
            </div>
          )}
        </div>
        <div className='offer-card-footer'>
          <div className='price'>
            <h3>
              {flightOffer.minSeatPrice ? t('ab {{price}}{{currency}}', {
                price: flightOffer.minSeatPrice,
                currency: flightOffer.minSeatPriceCurrency,
              }) : ''}
            </h3>
          </div>
          <button className='btn btn-primary'>{t('Jetzt Buchen')}</button>
        </div>
      </Link>
    );
  }
}

FlightOfferCard.propTypes = {
  flightOffer: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  link: PropTypes.string,
};

export default translate()(FlightOfferCard);



// WEBPACK FOOTER //
// ./src/App/Dashboard/FlightOffer/FlightOfferCard.js